import { AuthorizationStatus } from "@t-soft-io/retail-shared/api/models";

export type AuthorizationState = "pending" | "approved" | "rejected";
export type AuthorizationStatusValue =
  (typeof AuthorizationStatus)[keyof typeof AuthorizationStatus];

const STATUS_MAP: Partial<Record<string, AuthorizationState>> = {
  [AuthorizationStatus.AUTHORIZATION_STATUS_APPROVED]: "approved",
  [AuthorizationStatus.AUTHORIZATION_STATUS_DECLINED]: "rejected",
  [AuthorizationStatus.AUTHORIZATION_STATUS_CANCELLED]: "rejected",
  [AuthorizationStatus.AUTHORIZATION_STATUS_USED]: "rejected",
};

export function mapAuthorizationStatus(
  status: AuthorizationStatusValue | undefined,
): AuthorizationState {
  return (status && STATUS_MAP[status]) || "pending";
}

type PersistedPhase = "pending" | "approved";
interface PersistedAuthorization {
  id: number;
  phase: PersistedPhase;
}

const AUTHORIZATION_STORAGE_KEY = "pending_bet_authorization";
let _claimed = false;

export function claimPersistedAuthorization(): PersistedAuthorization | null {
  if (_claimed) return null;
  const stored = sessionStorage.getItem(AUTHORIZATION_STORAGE_KEY);
  if (stored) {
    _claimed = true;
    return JSON.parse(stored) as PersistedAuthorization;
  }
  return null;
}

export function persistAuthorization(id: number, phase: PersistedPhase): void {
  sessionStorage.setItem(
    AUTHORIZATION_STORAGE_KEY,
    JSON.stringify({ id, phase }),
  );
}

export function clearPersistedAuthorization(): void {
  sessionStorage.removeItem(AUTHORIZATION_STORAGE_KEY);
  _claimed = false;
}
